// DEPENDENCIES
import _ from "lodash";

// COMPONENTS
import { SubFormDefinition } from "../../../../../../../../utils/forms/components/FormSet";

// STORE
import { SelectedGroupsByProgressive } from "../../../../../../models/SelectedGroupsByProgressive";
import {
    GROUP_TYPE,
    TerminalGroupConfiguration,
    GameGroupConfiguration
} from "../../../../../../reducers/editingConfiguration.reducer";

// UTILS
import groupListOfType from "../../../../../Utils/full-group-list";
import getSelectableCoins from "../../../../../Utils/GetSelectableCoins/get-selectable-coins";
import { parseAvailableGroups } from "../../../../../Utils/parse-available-groups";
import buildFormGridFields from "../../../../../../../../utils/forms/builders/build-form-grid-fields";
import buildSchemaCompliantDefinition from "../../../../../../../../utils/forms/builders/build-schema-compliant-definition";

// CONTANTS AND DEFAULTS
import * as CONFIG_CONSTANTS from "../ProgressivesConfigurationSection.constants";

/* Load Constants */
import {
    checkRenderForProvider,
    checkDefaultForType,
    getNewGeneratedId,
    uuidv4
} from "../../../../../../../../utils/utils";
import { ProgressiveRulesSchema } from "../../../../../../reducers/schema.reducer";

export const fractionatedSubforms = props =>
    _.memoize(
        ({
            terminalGroups,
            gameGroups,
            selectedTerminalGroups,
            selectedGameGroups,
            schema,
            selectedGroupType,
            progressivesConfig,
            rules
        }): SubFormDefinition[] => {
            const coins = getSelectableCoins(props);

            return [
                _createFractionatedSubform(
                    schema,
                    terminalGroups,
                    gameGroups,
                    selectedTerminalGroups,
                    selectedGameGroups,
                    selectedGroupType,
                    progressivesConfig,
                    coins,
                    rules
                )
            ];
        }
    );

function _createFractionatedSubform(
    schema: any,
    terminalGroups: TerminalGroupConfiguration[],
    gameGroups: GameGroupConfiguration[],
    selectedTerminalGroups: SelectedGroupsByProgressive,
    selectedGameGroups: SelectedGroupsByProgressive,
    selectedGroupType: GROUP_TYPE,
    progressivesConfig,
    coins,
    rules: ProgressiveRulesSchema
): SubFormDefinition {
    const tempProgressiveSchema = schema.definitions.$fractionated_jackpot;

    const requiredGroupFields =
        selectedGroupType == null
            ? "groups_placeholder"
            : selectedGroupType == GROUP_TYPE.GAME
            ? "game_groups"
            : "terminal_groups";

    let progressiveSchema = {
        ...tempProgressiveSchema,
        required: [...tempProgressiveSchema.required, requiredGroupFields]
    };

   progressiveSchema.properties["id"]["unique"] = progressivesConfig.filter(progressive => progressive.type === "fractionated").map(progressive => progressive.id);

    if (selectedGroupType == null) {
        progressiveSchema.properties = {
            ...progressiveSchema.properties,
            [requiredGroupFields]: { type: "string" }
        };
    }

    const fullGroupList = groupListOfType(
        selectedGroupType,
        terminalGroups,
        gameGroups
    );

    const selectedGroupList = parseAvailableGroups(
        terminalGroups,
        selectedTerminalGroups,
        gameGroups,
        selectedGameGroups,
        "fractionated",
        selectedGroupType
    );

    const exclusiveFields = Object.keys(progressiveSchema.properties).filter(
        property => {
            return (
                progressiveSchema.properties[property].hasOwnProperty(
                    "exclusive"
                ) && progressiveSchema.properties[property].exclusive == true
            );
        }
    );

    const groupTypeFormDefinition = CONFIG_CONSTANTS.progressiveFormDefinition(
        selectedGroupType,
        coins,
        fullGroupList,
        selectedGroupList,
        [],
        rules.presets.map(preset => {
            return {
                value: preset.id,
                label: preset.name,
                individual_pot: null,
                certified: preset.certified,
                notes: preset.notes
            };
        }),
        [],
        exclusiveFields,
        undefined,
        'fractionated'
    );

    const formDefinition = buildSchemaCompliantDefinition(
        progressiveSchema,
        groupTypeFormDefinition,
        [
            CONFIG_CONSTANTS.SCHEMA_NAMES.ID,
            CONFIG_CONSTANTS.SCHEMA_NAMES.GLOBAL_JACKPOT_SOUND,
            CONFIG_CONSTANTS.SCHEMA_NAMES.GROUPS
        ]
    );

    return {
        formType: "fractionated",
        addLabel: "",
        emptyValue: defaultsfFactionated({
            schema: schema,
            progressivesConfig: progressivesConfig
        }),
        fields: buildFormGridFields(progressiveSchema, formDefinition, schema)
    };
}

const defaultsfFactionated = _.memoize(({ schema, progressivesConfig }) => {
    let defaults = {};
    defaults["terminal_groups"] = [];
    defaults["id"] = getNewGeneratedId("Fractionated", progressivesConfig);
    defaults["uuid"] = uuidv4();

    Object.keys(schema.definitions.$fractionated_jackpot.properties).map(
        item => {
            if (item !== "id" && item !== "uuid" && item != "fractionated_jackpot_list") {
                defaults[item] =
                    checkRenderForProvider(
                        item,
                        schema.definitions.$fractionated_jackpot.properties
                    ) &&
                    schema.definitions.$fractionated_jackpot.properties[item]
                        ? (schema.definitions.$fractionated_jackpot.properties[
                              item
                          ].convert
                              ? schema.definitions.$fractionated_jackpot
                                    .properties[item].default / 100
                              : schema.definitions.$fractionated_jackpot
                                    .properties[item].default) ||
                          checkDefaultForType(
                              schema.definitions.$fractionated_jackpot
                                  .properties[item].type
                          )
                        : null;
            }
        }
    );

    defaults["type"] = "fractionated";

    return defaults;
});
